import {TAB_NEAREST, TAB_SEARCH} from './constants';
import * as action from './action';
import * as mutation from './mutation';
import * as getter from './getter';
import {fetchContacts, search} from './api';

export const NAMESPACE = 'contact';

export const contactModule = {
    namespaced: true,
    state: {
        section: {
            type: null,
        },
        tabs: {
            selected: TAB_NEAREST
        },
        contacts: {
            data: [],
            processing: false,
            errors: [],
        }
    },
    getters: {
        [getter.ACTIVE_TAB]: (state) => state.tabs.selected,
        [getter.SECTION_TYPE]: (state) => state.section.type,

        [getter.CONTACTS]: (state) => state.contacts.data,
        [getter.CONTACTS_PROCESSING]: (state) => state.contacts.processing,
        [getter.CONTACTS_ERRORS]: (state) => state.contacts.errors,
        [getter.CONTACTS_NOT_FOUND]: (state, getters) => false === getters[getter.CONTACTS_PROCESSING] && 0 === getters[getter.CONTACTS].length && 0 === getters[getter.CONTACTS_ERRORS].length,
    },
    actions: {
        [action.SET_ACTIVE_TAB]: ({commit}, tabName) => commit(mutation.SELECT_TAB, tabName),
        [action.SET_SECTION_TYPE]: ({commit}, sectionType) => commit(mutation.SELECT_SECTION, sectionType),

        [action.CLEAR_CONTACTS]: ({commit}) => commit(mutation.SET_CONTACTS, []),

        [action.FETCH_CONTACT_BY_ADDRESS]: ({commit, getters}, address) => {
            commit(mutation.CONTACTS_PROCESSING, true);
            commit(mutation.SET_CONTACTS_ERROR, []);
            commit(mutation.SET_CONTACTS, []);
            return search({address}, getters[getter.SECTION_TYPE], TAB_SEARCH)
                .then((data) => commit(mutation.SET_CONTACTS, data))
                .catch((error) => commit(mutation.SET_CONTACTS_ERROR, [error.message]))
                .finally(() => commit(mutation.CONTACTS_PROCESSING, false));
        },
        [action.FETCH_CONTACTS]: ({commit, getters}, parameters) => {
            commit(mutation.CONTACTS_PROCESSING, true);
            commit(mutation.SET_CONTACTS_ERROR, []);
            commit(mutation.SET_CONTACTS, []);
            return fetchContacts(parameters, getters[getter.SECTION_TYPE], getters[getter.ACTIVE_TAB])
                .then((data) => commit(mutation.SET_CONTACTS, data))
                .catch((error) => commit(mutation.SET_CONTACTS_ERROR, [error.message]))
                .finally(() => commit(mutation.CONTACTS_PROCESSING, false));
        },
    },
    mutations: {
        [mutation.SELECT_TAB]: (state, tabName) => state.tabs.selected = tabName,
        [mutation.SELECT_SECTION]: (state, sectionType) => state.section.type = sectionType,

        [mutation.SET_CONTACTS]: (state, contacts) => state.contacts.data = contacts,
        [mutation.CONTACTS_PROCESSING]: (state, status) => state.contacts.processing = status,
        [mutation.SET_CONTACTS_ERROR]: (state, errors) => state.contacts.errors = errors,
    },
}



// WEBPACK FOOTER //
// ./src/components/contact/store.js